<template>
    <div id="estados-component" class="rel">
        <b-modal v-model="showModal" hide-footer size="xl" centered scrollable :title="titleModal">
            <form id="formCrud" class="formCrud">
                <div class="row scr-gap-15-0">
                    <div class="col-12 col-md-6 col-xl-4">
                        <input placeholder="Nombre del Estado" type="text" class="al-inputs required scr-input"
                               name="estado" id="estado" v-model="edo.estado" data-name-input="Nombre del Estado"/>
                        <label for="estado" class="scr-supertext scr-extra">Nombre del Estado</label>
                    </div>
                    <div class="col-12 col-md-6 col-xl-4">
                        <input placeholder="Abreviatura" type="text" class="al-inputs required scr-input" name="estado"
                               id="abr-estado" v-model="edo.abrv" data-name-input="Abreviación"/>
                        <label for="abr-estado" class="scr-supertext scr-extra">Abreviatura</label>
                    </div>
                    <div class="col-12 col-md-6 col-xl-2">
                        <select v-model="edo.status" data-select="on" data-name-input="Selecciona un Status" id="">
                            <option :value="0">Activo</option>
                            <option :value="1">Inactivo</option>
                        </select>
                    </div>
                    <div class="col-12 col-md-6 col-xl-2">
                        <button id="dyn-button" type="button" class="formSubmit" v-on:click="guardar()">{{
                                tituloBtn
                            }}
                        </button>
                    </div>
                </div>
            </form>
        </b-modal>
        <main id="mainContent" class="padFixBoth">
            <div class="view">
                <div class="barSettings">
                    <div class="row">
                        <div class="col-12 col-xl-2 mb-3 mb-sm-0">
                           <b-pagination pills align="fill" :hide-goto-end-buttons="true" :limit="3" v-model="pagination.current_page"
                                          :total-rows="pagination.total" :per-page="pagination.per_page"
                                          aria-controls="my-table" v-on:change="onChange"></b-pagination>
                        </div>
                        <div class="col-12 col-xl-6 mb-3 mb-sm-0">
                            <input id="filter-input" class="al-inputs scr-input" v-model="filter" type="search"
                                   placeholder="Buscar por palabra">
                            <label for="filter-input" class="scr-supertext scr-extra">Buscar por palabra</label>
                        </div>
                        <div class="col-12 col-xl-2 mb-3 mb-sm-0 cont_select">
                            <select id="change_result" class="float" v-model="params.limit" v-on:change="changeLimit">
                                <option :value="10">10</option>
                                <option :value="20">20</option>
                                <option :value="30">30</option>
                                <option :value="50">50</option>
                                <option :value="100">100</option>
                            </select>
                        </div>
                        <div class="col-12 col-md-2 mb-3 mb-sm-0">
                            <button type="button" class="formSubmit" v-on:click="openModalsProviders()">{{
                                    tituloBtn
                                }}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="row">
                        <b-table stacked="md" id="my-table" striped hover :fields="fields" :busy="isBusy"
                                 :items="pagination.data" :filter="filter">
                            <template #head(Acciones)="{item}">
                                <i class="fa-solid fa-gear"></i>
                            </template>
                            <template #cell(Estado)="{item}">
                                {{ item.estado }}
                            </template>
                            <template #cell(Abreviacion)="{item}">
                                {{ item.abrv }}
                            </template>
                            <template #cell(Status)="{item}">
                                <span v-if="item.status===1" class="badge rounded-pill text-bg-danger">Inactivo</span>
                                <span v-else class="badge rounded-pill text-bg-success">Activo</span>
                            </template>
                            <template #cell(Acciones)="{item}">
                                <div class="dropdown">
                                    <button class="btn btn-warning dropdown-toggle" type="button"
                                            id="dropdownMenuButton"
                                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fas fa-cogs"></i>
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">

                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="modificar=true; updateReg(item)">Editar</a>
                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="onClickDelete(item.id)">Borrar</a>
                                    </div>
                                </div>
                            </template>
                            <template #table-busy>
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Cargando...</strong>
                                </div>
                            </template>
                        </b-table>
                        <div class="col-12 col col-xl-2">
                           <b-pagination pills align="fill" :hide-goto-end-buttons="true" :limit="3" v-model="pagination.current_page"
                                          :total-rows="pagination.total" :per-page="pagination.per_page"
                                          aria-controls="my-table" v-on:change="onChange"></b-pagination>
                        </div>
                    </div>
                </div>
            </div>
            <!--            <table id="listReg" class="table table-bordered">
                            <thead class="thead-dark">
                            <tr>
                                <th><strong>Estado</strong></th>
                                <th><strong>Abreviación</strong></th>
                                <th><strong>Status</strong></th>
                                <th>Acciones</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="estado in estados" :key="estado.id">
                                <td>{{ estado.estado }}</td>
                                <td>{{ estado.abrv }}</td>
                                <td>
                                    <span v-if="estado.status==1" class="badge rounded-pill text-bg-danger">Inactivo</span>
                                    <span v-else class="badge rounded-pill text-bg-success">Activo</span>
                                </td>
                                <td>
                                    <div class="dropdown">
                                        <button class="btn btn-warning dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <i class="fas fa-cogs"></i>
                                        </button>
                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                            <a class="dropdown-item" href="javascript:void(0)" v-on:click="modificar=true; updateReg(estado)">Editar</a>
                                            <a class="dropdown-item" href="javascript:void(0)" v-on:click="onClickDelete(estado.id)">Borrar</a>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>-->
        </main>
    </div>
</template>

<script>
import {myMixins} from "../mixins/myMixins";
import {estadoService} from "../../Services/States.service";

export default {
    name: "estado",
    mixins: [myMixins],
    data() {
        return {
            isBusy: false,
            filter: null,
            edo: {
                id: '',
                estado: '',
                abrv: '',
                status: 0,
                logo_file: '',
                contrato_file: '',
                cotizacion_file: '',
            },
            pagination: {
                current_page: 1,
                data: [],
                first_page_url: '',
                from: 0,
                last_page: 0,
                last_page_url: '',
                links: [],
                next_page_url: '',
                path: '',
                per_page: 0,
                prev_page_url: '',
                to: 0,
                total: 0,
            },
            fields: [
                {key: 'Estado'},
                {key: 'Abreviacion'},
                {key: 'Status'},
                {key: 'Acciones'}
            ],
            params: {
                limit: 10,
                page: 1,
            },
            modificar: false,
            modal: 0,
            tituloModal: '',
            estados: [],
            loading: true,
            myTableFlag: false,
            tituloBtn: 'Agregar',
        }
    },
    methods: {
        updateReg(data = {}) {
            this.modal = 1
            if (this.modificar) {
                this.tituloBtn = 'Actualizar'
                this.edo = data;
            } else {
                this.tituloBtn = 'Agregar';
                this.setEmpty();
            }
        },
        async onClickDelete(id) {
            let resp = '';
            resp = await estadoService.deleteOne(id);
            this.getAlert(resp.process);
            await this.index();
        },
        async index() {
            this.pagination = await estadoService.getMany(this.params);
        },
        async guardar() {
            let resp = '';
            let respVal = this.valFormulariosV3();
            //actualizando
            if (respVal) {
                this.disableSubmitBtn(true);
                if (this.modificar) {
                    resp = await estadoService.updateOne(this.edo.id, this.edo);
                } else {
                    resp = await estadoService.saveOne(this.edo);
                }
                this.disableSubmitBtn(false);
            }
            this.getAlert(resp.process);
            await this.index();
            this.modificar = false;
        },
        setEmpty() {
            this.edo = {
                id: '',
                estado: '',
                abrv: '',
                status: 0,
                logo_file: '',
                contrato_file: '',
                cotizacion_file: '',
            }
        },
        onChange(page) {
            this.params.page = page;
            this.index();
        },
        changeLimit() {
            this.index();
        },
    },
    created() {
        this.index();
    }
}
</script>

